// extracted by mini-css-extract-plugin
export default {"topskills_container":"TopSkills_topskills_container__4ZTg8","divider":"TopSkills_divider__IyZLm"};